import axios from 'axios';
import { NOWID_PROXY_URL } from '../config';

/**
 * SophieCustomerTypeService - Handles SOAP API call to check customer type
 * Replaces: ch3 curl calls in functions-customs.php that check Sophie/subscription status
 * This service calls the SBIMSExt SOAP API to determine customer type based on FSA
 * All calls are routed through the NowID proxy for security and consistency
 */
const SophieCustomerTypeService = {
  /**
   * Check Sophie Customer Type via SOAP API
   * Replaces: chkSophieCustType SOAP call (formerly ch3 curl handle)
   * @param {string} fsa - Subscription Account ID
   * @returns {Promise} Response with subStatus (001, 005, 004, etc.)
   */
  checkCustomerType: async (fsa) => {
    try {
      if (!fsa) {
        throw new Error('FSA is required for customer type check');
      }

      // Call via NowID proxy endpoint (handles SOAP envelope generation)
      const endpoint = `${NOWID_PROXY_URL}`;
      
      const response = await axios.post(endpoint, {
        proxyTarget: 'sophie',
        endpoint: 'SBIMSExt/chkSophieCustType',
        method: 'SOAP',
        payload: {
          fsa: fsa,
        },
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('✅ SophieCustomerTypeService.checkCustomerType success:', {
        fsa,
        subStatus: response.data?.subStatus,
      });

      return {
        subStatus: response.data?.subStatus,
        resultCode: response.data?.resultCode,
        resultMessage: response.data?.resultMessage,
        rawResponse: response.data,
      };
    } catch (error) {
      console.error('❌ SophieCustomerTypeService.checkCustomerType failed:', {
        fsa,
        error: error.message,
      });
      throw error;
    }
  },

  /**
   * Helper to map sub status to customer type
   * Maps the SOAP response subStatus to readable customer type
   * @param {string} subStatus - The subscription status from SOAP API
   * @returns {object} Customer type info with cust_type and readable_cust_type
   */
  mapSubStatusToCustomerType: (subStatus) => {
    const statusMap = {
      '001': { cust_type: '001', readable_cust_type: 3, description: 'User Type 3 (VIM - Logged In & Binded but Cannot Upgrade)' },
      '005': { cust_type: '005', readable_cust_type: 4, description: 'User Type 4 (Combo / Pack - Logged In & Binded and can Upgrade)' },
      '004': { cust_type: '004', readable_cust_type: 5, description: 'User Type 5 (Pack/PCD - Logged In & Binded and can Upgrade)' },
      '003': { cust_type: '003', readable_cust_type: 6, description: 'User Type 6 (Starter Pack / Free Channels)' },
      '002': { cust_type: '002', readable_cust_type: 7, description: 'User Type 7 (Lamma Island - Logged In & Binded but Cannot Upgrade)' },
      '000': { cust_type: '000', readable_cust_type: 7, description: 'User Type 7 (Lamma Island - Logged In & Binded but Cannot Upgrade)' },
    };

    return statusMap[subStatus] || {
      cust_type: subStatus,
      readable_cust_type: 0,
      description: 'Unknown',
    };
  },
};

export default SophieCustomerTypeService;
